import { Text } from '@frontend/design-system';

type ContactItemProps = {
  label: string;
  value: string;
};

export const ContactItem = ({ label, value }: ContactItemProps) => {
  return (
    <div>
      <Text size='small' color='subdued'>
        {label}
      </Text>
      <Text>{value}</Text>
    </div>
  );
};
